// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onerepmax-tool-container {
  max-width: 800px;
  margin: 2rem auto;
  background: rgba(0, 0, 0, 0.2);
  color: white;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 2.5rem 2rem;
}

.onerepmax-history-toggle {
  margin-bottom: 1.5rem;
  padding: 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
}

.onerepmax-toggle-button {
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.onerepmax-history-content {
  margin-top: 1rem;
  font-size: 0.9rem;
}

.onerepmax-input-card {
  padding: 2rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}

.onerepmax-input-group {
  margin-bottom: 1.5rem;
}

.onerepmax-input-group label {
  font-size: 1.2rem;
  display: block;
  margin-bottom: 0.5rem;
}

.onerepmax-input-group input,
.onerepmax-input-group select {
  padding: 0.75rem;
  font-size: 1.1rem;
  width: 120px;
}

.onerepmax-info-icon {
  cursor: pointer;
  margin-left: 0.5rem;
  font-size: 2rem;
  color: #007aff;
}

.onerepmax-formula-info {
  margin-top: 0.75rem;
  font-size: 0.95rem;
  background: #f9f9f9;
  padding: 1rem;
  border-radius: 6px;
}

.onerepmax-results-card {
  padding: 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}

.onerepmax-one-rm-result {
  color: #abc7a4;
}

.onerepmax-one-rm-result span {
  color: rgb(24, 255, 24);
}

.onerepmax-rep-max-table {
  width: 100%;
  border-collapse: collapse;
}

.onerepmax-rep-max-table th,
.onerepmax-rep-max-table td {
  border-bottom: 1px solid #ddd;
  padding: 0.5rem;
}

.onerepmax-highlight-row {
  background-color: rgba(0,150,0,0.4);
  font-weight: bold;
}

.onerepmax-disclaimer-card {
  padding: 1rem;
  border: 1px dashed #aaa;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
}

.onerepmax-footer {
  margin-top: 2rem;
  text-align: center;
}

.onerepmax-share-button {
  padding: 0.75rem 1.5rem;
  background: #007aff;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/OneRepMaxTool.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".onerepmax-tool-container {\n  max-width: 800px;\n  margin: 2rem auto;\n  background: rgba(0, 0, 0, 0.2);\n  color: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\n  padding: 2.5rem 2rem;\n}\n\n.onerepmax-history-toggle {\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n}\n\n.onerepmax-toggle-button {\n  padding: 0.5rem 1rem;\n  font-size: 0.9rem;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n}\n\n.onerepmax-history-content {\n  margin-top: 1rem;\n  font-size: 0.9rem;\n}\n\n.onerepmax-input-card {\n  padding: 2rem;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n}\n\n.onerepmax-input-group {\n  margin-bottom: 1.5rem;\n}\n\n.onerepmax-input-group label {\n  font-size: 1.2rem;\n  display: block;\n  margin-bottom: 0.5rem;\n}\n\n.onerepmax-input-group input,\n.onerepmax-input-group select {\n  padding: 0.75rem;\n  font-size: 1.1rem;\n  width: 120px;\n}\n\n.onerepmax-info-icon {\n  cursor: pointer;\n  margin-left: 0.5rem;\n  font-size: 2rem;\n  color: #007aff;\n}\n\n.onerepmax-formula-info {\n  margin-top: 0.75rem;\n  font-size: 0.95rem;\n  background: #f9f9f9;\n  padding: 1rem;\n  border-radius: 6px;\n}\n\n.onerepmax-results-card {\n  padding: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n}\n\n.onerepmax-one-rm-result {\n  color: #abc7a4;\n}\n\n.onerepmax-one-rm-result span {\n  color: rgb(24, 255, 24);\n}\n\n.onerepmax-rep-max-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.onerepmax-rep-max-table th,\n.onerepmax-rep-max-table td {\n  border-bottom: 1px solid #ddd;\n  padding: 0.5rem;\n}\n\n.onerepmax-highlight-row {\n  background-color: rgba(0,150,0,0.4);\n  font-weight: bold;\n}\n\n.onerepmax-disclaimer-card {\n  padding: 1rem;\n  border: 1px dashed #aaa;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  font-size: 0.9rem;\n}\n\n.onerepmax-footer {\n  margin-top: 2rem;\n  text-align: center;\n}\n\n.onerepmax-share-button {\n  padding: 0.75rem 1.5rem;\n  background: #007aff;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
